import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button, LoadMore } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import Http from 'services/http2';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import CompanyService from 'services/company2';
import * as MobileActions from 'actions/index.ts';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import BillingService from 'services/billing';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import ModalService from 'services/modal';
import Big from 'big.js';
import CommonFns from 'functions/common.ts';
let isBig = Util.isBig;

function InvoiceDetail(props) {
  const Config = {
    sale: {
      title: '客户发票详情',
      apiPath: '/invoiceOrder/detail',
      deleteApiPath: '/invoiceOrder/delete',
      recallApiPath: '/invoiceOrder/revocation',
      publishApiPath: '/invoiceOrder/publish',
      confirmApiPath: '/invoiceOrder/confirm',
      invalidApiPath: '/invoiceOrder/invalid',
      companyCodeKey: 'customerCode',
      companyNameKey: 'innerCustomerName',
      canSave: false,
      canApply: false,
      canRecallApply: false,
      canPublish: false,
      canDelete: false,
      canRecall: false,
      canInvalid: false,
      canRemaind: false,
      arrEnumField: [
        {
          mainKey: 'B02_Inv_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Inv_Invoice_Type',
          subKey: 'invoiceType',
          value: 'invoiceTypeName'
        },
        {
          mainKey: 'B02_Order_Sync_Status',
          subKey: 'syncStatus',
          value: 'syncStatusName'
        },
        {
          mainKey: 'B2b_Erp_AccountsType',
          subKey: 'accountsTypeCode',
          value: 'accountsTypeName'
        }
      ],
      idField: 'invXkNo'
    },
    purchase: {
      title: '采购发票详情',
      apiPath: '/vInvoiceOrder/detail',
      deleteApiPath: '/vInvoiceOrder/delete',
      recallApiPath: '/vInvoiceOrder/revocation',
      publishApiPath: '/vInvoiceOrder/publish',
      confirmApiPath: '/vInvoiceOrder/confirm',
      invalidApiPath: '/vInvoiceOrder/invalid',
      companyCodeKey: 'companyCode',
      companyNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_Inv_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Inv_Invoice_Type',
          subKey: 'invoiceType',
          value: 'invoiceTypeName'
        },
        {
          mainKey: 'B02_Order_Sync_Status',
          subKey: 'syncStatus',
          value: 'syncStatusName'
        },
        {
          mainKey: 'B2b_Erp_AccountsType',
          subKey: 'accountsTypeCode',
          value: 'accountsTypeName'
        }
      ],
      idField: 'invXkNo',
      wfmCode: '1003'
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    moreSign1,
    moreSign2,
    handleMore,
    decimalPlace,
    fileList,
    setShowLoading,
    setFileList,
    setRedirect,
    detail,
    setDetail,
    workflow,
    self
  } = useDetail(props, config);

  const { state, dispatch } = useContext(ActionContext);
  const [invoiceList, setInvoiceList] = useState([]); //发票信息
  const [pordAmountInfo, setPordAmountInfo] = useState({}); //发票金额
  const [invoiceAmount, setInvoiceAmount] = useState('');
  const [prodList, setProdList] = useState(''); //开票明细
  self.afterGetDetail = function (data) {
    data.taxRateShow = Big(data.taxRate).times(100).valueOf(); //按百分比显示税率
    setDetail(data);
    setInvoiceList(data.infoDetailList);
    // 计算票面总额
    if (!Util.isEmpty(data.infoDetailList)) {
      let totalAmount = Big(0);
      data.infoDetailList.forEach(item => {
        if (isBig(item.totalAmount)) {
          totalAmount = totalAmount.plus(item.totalAmount);
        }
        if (item.id && !item.amount) {
          //详情接口没有返回未税金额时，需计算
          if (item.totalAmount && item.taxAmount) {
            item.amount = parseFloat(
              Big(item.totalAmount).minus(item.taxAmount).valueOf()
            ); //未税金额 = 输入金额 - 税额
          }
        }
      });
      setInvoiceList(data.infoDetailList);
      setInvoiceAmount(parseFloat(totalAmount));
    }
    this.isInvalidFlag = invoiceList.every(item => item.invalidFlag === 1);
    this.isTaxationPrintFlag = invoiceList.some(
      item => item.taxationPrintFlag === 1
    );
    getPordAmount();
    getProdList();
    updateBtnStatus();
  };
  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);
  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);
  //获取提交参数
  function getPostbody(apiPath) {
    let postbody = {
      invXkNo: detail.invXkNo,
      companyCode: companyCode,
      apiPath: apiPath
    };
    return postbody;
  }
  //更新按钮状态 status
  function updateBtnStatus() {
    config.canSave =
      User.checkAuth('20040202') && [0, 4, 5, 6, 7].includes(detail.status);
    config.canApply =
      User.checkAuth('20040202') &&
      detail.deliveryApplyFlag === 1 &&
      [0, 2, 3].includes(detail.status);
    config.canRecallApply =
      User.checkAuth('20040202') && [1].includes(detail.status);
    config.canDelete = User.checkAuth('20040202') && detail.status === 0;
    config.canRecall = User.checkAuth('20040204') && detail.status === 5;
    config.canInvalid =
      User.checkAuth('20040205') && ![0, 8, 9].includes(detail.status);
    config.canPublish =
      User.checkAuth('20040205') &&
      ([4, 6, 7].includes(detail.status) ||
        (detail.status === 0 && detail.deliveryApplyFlag === 0));
    config.canRemaind = User.checkAuth('20040203') && detail.status === 5;
  }
  function showFileList(businessType, obj) {
    const { actions } = props;
    let businessKey = businessType === 16 ? obj.invXkNoLineNoKey : '',
      xkNo = obj.poXkNo,
      lineNo = obj.lineNo,
      cCode = obj[config.companyCodeKey];
    setShowLoading(true);
    CompanyService.getFileList(
      businessType,
      businessKey,
      self.id,
      lineNo,
      cCode
    ).then(res => {
      setShowLoading(false);
      if (Array.isArray(res)) {
        let arr = res.map(item => {
          return { ...item };
        });
        setFileList(arr);
      }
    });
    actions.openDownloadModal();
  }
  //获取开票明细总额
  function getPordAmount() {
    let postbody = {
      apiPath: self.isPurchase
        ? '/vInvoiceOrder/invoiceAmount'
        : '/invoiceOrder/invoiceAmount',
      companyCode: companyCode,
      invXkNo: self.id
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        setPordAmountInfo(response.data);
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }
  //获取开票明细
  function getProdList() {
    let postbody = {
      apiPath: self.isPurchase
        ? '/vInvoiceOrder/mobileListProdDetail'
        : '/invoiceOrder/mobileListProdDetail',
      companyCode: companyCode,
      invXkNo: self.id
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let arrInvType = [];
        arrInvType = self.isPurchase
          ? [
              {},
              {
                name: '送货单',
                path: '/sale/delivery/note/detail/'
              },
              {
                name: '退货单',
                path: '/sale/delivery/return/detail/'
              },
              {
                name: '费用单',
                path: '/sale/billing/cost/detail/'
              },
              {},
              {
                name: '费用采购单',
                path: '/sale/customer/detail/'
              },
              {
                name: 'VMI对账明细',
                path: '/sale/billing/statement/detail/'
              }
            ]
          : [
              {},
              {
                name: '送货单',
                path: '/purchase/receive/notify/detail/'
              },
              {
                name: '退货单',
                path: '/purchase/receive/return/detail/'
              },
              {
                name: '费用单',
                path: '/purchase/billing/cost/detail/'
              },
              {},
              {
                name: '费用采购单',
                path: '/purchase/order/detail/'
              },
              {
                name: 'VMI对账明细',
                path: '/purchase/billing/statement/detail/'
              }
            ];

        let list = response.data.list;
        list.forEach(item => {
          let xkNo = item.invType === '1' ? item.dnXkNo : item.billXkNo;
          if (arrInvType[item.invType]) {
            item.invTypeName = arrInvType[item.invType].name;
            item.routerLink = arrInvType[item.invType].path + xkNo;
          }
          item.innerNo = item.invType === '1' ? item.dnXkNo : item.billInnerNo; //显示单号
          item.invoceRate = item.invoceRate || 0;
          item.taxRateShow = isBig(item.taxRate)
            ? parseFloat(Big(item.taxRate).times(100).valueOf())
            : ''; //按百分比转换税率
          item.invoceRateShow = parseFloat(
            Big(item.invoceRate).times(100).valueOf()
          ); //按百分比转换额外附加税率
        });

        setProdList(list);
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  //删除草稿
  function handleDelete() {
    let postbody = getPostbody(config.deleteApiPath);
    let url = self.isPurchase
      ? '/mp/purchase/billing/invoice/list'
      : '/mp/sale/billing/invoice/list';
    BillingService.deleteInvoice(
      postbody,
      () => {
        setRedirect(url);
      },
      dispatch
    );
  }

  //撤回
  async function handleRecall() {
    let wfStatus = await queryWorkflowStatus();
    if (wfStatus === 1) {
      ModalService.showError(
        '采购方审批流程为【审批中】，不允许撤回',
        dispatch
      );
      return;
    }
    let postbody = getPostbody(config.recallApiPath);
    BillingService.recallPurchaseInvoice(
      postbody,
      () => {
        dispatch({ type: 'hideReject' });
        self.getDetail();
      },
      dispatch
    );
  }

  //审批状态 0-待送审 1-审批中 2-审批完成
  async function queryWorkflowStatus() {
    let res;
    if (self.isPurchase) {
      return res;
    }
    let postbody = {
      ...getPostbody('/invoiceOrder/queryWorkflowStatus'),
      customerCode: detail.customerCode
    };
    setShowLoading(true);
    await Http.post('/api/cloudCenter', postbody).then(response => {
      setShowLoading(false);
      if (response.success) {
        res = response.data;
      }
    });
    return res;
  }

  //确认发出
  function publish() {
    let postbody = getPostbody(config.publishApiPath);
    BillingService.publishInvoice(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //确认
  function confirm() {
    let postbody = getPostbody(config.confirmApiPath);
    BillingService.confirmInvoice(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //作废
  function invalid() {
    let postbody = getPostbody(config.invalidApiPath);
    BillingService.invalidInvoice(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }
  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }
  return (
    <div>
      <TopNav inited={inited} />
      <div className="m-details-container">
        <div className="m-details-item">
          <div className="details-item-title">
            <label>基础信息</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label">发票金额</span>
                  <div className="field-value">
                    {formatNumber(
                      detail.totalAmount,
                      decimalPlace.Amount_Decimal_Place
                    )}
                  </div>
                </li>
                <li>
                  <span className="field-label">状态</span>
                  <div className="field-value">
                    <span
                      className={
                        'u-sign ' +
                        CommonFns.getStatusClass(
                          'B02_Inv_Status',
                          detail.status
                        )
                      }
                    >
                      {detail.statusName}
                    </span>
                  </div>
                </li>
                <li>
                  <span className="field-label">发布时间</span>
                  <div className="field-value">
                    {formatDate(detail.publishTime)}
                  </div>
                </li>
                {/* 审批流状态 仅开启后才显示 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批环节</span>
                    <div className="field-value">
                      <WorkflowStatus
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                      />
                    </div>
                  </li>
                )}
                {/* 审批流按钮 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批操作</span>
                    <div className="field-value">
                      <WorkflowButtons
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                        onChange={() => {
                          self.getDetail();
                        }}
                      />
                    </div>
                  </li>
                )}
                <li>
                  <span className="field-label">
                    {self.isPurchase ? '采购方' : '客户'}
                  </span>
                  <div className="field-value">
                    {self.isPurchase
                      ? self.companyInfo.companyName
                      : detail.customerName}
                  </div>
                </li>
                <li>
                  <span className="field-label">供应商</span>
                  <div className="field-value">
                    {detail.innerVendorName}({detail.innerVendorCode})
                  </div>
                </li>
                <li>
                  <span className="field-label">来源</span>
                  <div className="field-value">
                    {detail.invoiceOriginator === 0 ? '供应商' : '本方'}
                  </div>
                </li>
                <li>
                  <span className="field-label">币别</span>
                  <div className="field-value">{detail.currencyName}</div>
                </li>
                <li>
                  <span className="field-label">发票类型</span>
                  <div className="field-value">{detail.invoiceTypeName}</div>
                </li>
                <li>
                  <span className="field-label">发票税率</span>
                  <div className="field-value">{detail.taxRateShow + '%'}</div>
                </li>
                <li>
                  <span className="field-label">凭证号</span>
                  <div className="field-value">{detail.payCredentials}</div>
                </li>
                <li>
                  <span className="field-label">到期日</span>
                  <div className="field-value">
                    {formatDate(detail.payExpiredDate)}
                  </div>
                </li>
                <li>
                  <span className="field-label">账款类型</span>
                  <div className="field-value">{detail.accountsTypeName}</div>
                </li>
                <li>
                  <span className="field-label">备注</span>
                  <div className="field-value">{detail.remark}</div>
                </li>
                <li>
                  <span className="field-label">快递单号</span>
                  <div className="field-value">{detail.courierNumber}</div>
                </li>
                {/* {detail.attachCount > 0 &&
              (!self.isPurchase ||
                User.checkAuth('10010112') ||
                User.checkAuth('10010107')) && (
                <li className={moreSign1 ? 'hide' : ''}>
                  <span className="field-label">订单附件</span>
                  <div className="field-value">
                    <span
                      className="attachment"
                      onClick={() => showFileList(61, detail)}
                    >
                      {detail.attachCount}个附件
                      <i className="icon-attachment"></i>
                    </span>
                  </div>
                </li>
              )} */}
              </ul>
            </div>
          </div>
          {/* <div
            className={moreSign1 ? 'm-more' : 'm-more m-more-open'}
            onClick={() => {
              handleMore(1);
            }}
          >
            {moreSign1 && '更多'}
            {!moreSign1 && '收起'}
            <i className="icon-down"></i>
          </div> */}
        </div>
        <div className="m-details-item">
          <div className="details-item-title">
            <label>发票信息</label>
          </div>
          <div className="details-item-content">
            {invoiceList?.length > 0 &&
              invoiceList.map((item, index) => (
                <div className="content-line line-list-item" key={index}>
                  <div className="line-list-item-title">
                    <span>序号 {index + 1}</span>
                  </div>
                  <ul className="field-list">
                    <li>
                      <span className="field-label">发票代码</span>
                      <div className="field-value">{item.invoiceCode}</div>
                    </li>
                    <li>
                      <span className="field-label">发票类型</span>
                      <div className="field-value">
                        {detail.invoiceTypeName}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">开票日期</span>
                      <div className="field-value">
                        {formatDate(item.invoiceTime)}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">发票金额</span>
                      <div className="field-value">
                        {formatNumber(
                          item.totalAmount,
                          decimalPlace.Amount_Decimal_Place
                        )}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">发票号码</span>
                      <div className="field-value">
                        {item.invoiceNumber}
                        {item.invoiceNumberSuffix
                          ? ' - ' + item.invoiceNumberSuffix
                          : ''}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">发票税率</span>
                      <div className="field-value">
                        {detail.taxRateShow + '%'}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">有效日期</span>
                      <div className="field-value">
                        {formatDate(item.validityTime)}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">未税金额</span>
                      <div className="field-value">
                        {formatNumber(
                          item.amount,
                          decimalPlace.Amount_Decimal_Place
                        )}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">税额</span>
                      <div className="field-value">
                        {formatNumber(
                          item.taxAmount,
                          decimalPlace.Amount_Decimal_Place
                        )}
                      </div>
                    </li>
                    <li>
                      <span className="field-label"></span>
                      <div className="field-value">
                        <span
                          className={item.invoiceKind === '2' ? 'blue' : 'red'}
                        >
                          {item.invoiceKind === '2' ? '蓝字发票' : '红字发票'}
                        </span>
                      </div>
                    </li>
                    {item.fileMd5s?.length > 0 && (
                      <li>
                        <span className="field-label"></span>
                        <div className="field-value">
                          <span
                            className="attachment"
                            onClick={() => showFileList(16, item)}
                          >
                            {item.fileMd5s}个附件
                            <i className="icon-attachment"></i>
                          </span>
                        </div>
                      </li>
                    )}
                  </ul>
                </div>
              ))}
          </div>
          {!invoiceList?.length === 0 && (
            <LoadMore showLine> 暂无数据</LoadMore>
          )}
        </div>

        <div className="m-details-item">
          <div className="details-item-title">
            <label>发票金额</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label">票面总额</span>
                  <div className="field-value">
                    <span className="blue">
                      {Util.isEmpty(invoiceList)
                        ? formatNumber(
                            pordAmountInfo.totalActualInvoiceAmount,
                            2
                          )
                        : formatNumber(invoiceAmount, 2)}
                    </span>
                  </div>
                </li>
                <li>
                  <span className="field-label">调整金额</span>
                  <div className="field-value">
                    <span className="blue">
                      {formatNumber(pordAmountInfo.discountAmount, 2)}
                    </span>
                  </div>
                </li>
                <li>
                  <span className="field-label">单据总额</span>
                  <div className="field-value">
                    <span className="blue">
                      {formatNumber(
                        pordAmountInfo.totalAmount,
                        decimalPlace.Amount_Decimal_Place
                      )}
                    </span>
                  </div>
                </li>
                <li>
                  <span className="field-label">含税总额</span>
                  <div className="field-value">
                    <span className="blue">
                      {formatNumber(
                        pordAmountInfo.taxYesAmount,
                        decimalPlace.Amount_Decimal_Place
                      )}
                    </span>
                  </div>
                </li>
                <li>
                  <span className="field-label">未税总额</span>
                  <div className="field-value">
                    <span className="blue">
                      {formatNumber(
                        pordAmountInfo.taxNoAmount,
                        decimalPlace.Amount_Decimal_Place
                      )}
                    </span>
                  </div>
                </li>
                <li>
                  <span className="field-label">税额</span>
                  <div className="field-value">
                    <span className="blue">
                      {formatNumber(
                        pordAmountInfo.taxAmount,
                        decimalPlace.Amount_Decimal_Place
                      )}
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="m-details-item">
          <div className="details-item-title">
            <label>开票明细</label>
          </div>
          <div className="details-item-content">
            {prodList?.length > 0 &&
              prodList.map((item, index) => (
                <div className="content-line line-list-item" key={index}>
                  <div className="line-list-item-title">
                    <span>序号 {index + 1}</span>
                  </div>
                  <ul className="field-list">
                    <li>
                      <span className="field-label">产品编码</span>
                      <div className="field-value">{item.productCode}</div>
                    </li>
                    <li>
                      <span className="field-label">产品名称</span>
                      <div className="field-value">{item.productName}</div>
                    </li>
                    <li>
                      <span className="field-label">产品规格</span>
                      <div className="field-value">{item.productScale}</div>
                    </li>
                    <li>
                      <span className="field-label">类型</span>
                      <div className="field-value">{item.invTypeName}</div>
                    </li>
                    <li>
                      <span className="field-label">单据金额</span>
                      <div className="field-value">
                        {item.invType === '2' ? '-' : ''}{' '}
                        <span>
                          {formatNumber(
                            item.isContainTax === 1
                              ? item.invoicingTotalTaxAmount
                              : item.invoicingTotalAmount,
                            decimalPlace.Amount_Decimal_Place
                          )}
                        </span>
                      </div>
                    </li>
                    <li>
                      <span className="field-label">票面金额</span>
                      <div className="field-value">
                        {formatNumber(
                          item.actualInvoiceAmount,
                          decimalPlace.Amount_Decimal_Place
                        )}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">币别</span>
                      <div className="field-value">{item.currencyName}</div>
                    </li>
                    <li>
                      <span className="field-label">是否含税</span>
                      <div className="field-value">
                        {item.isContainTax === 1 ? '含税' : '不含税'}
                        <span
                          className={
                            item.taxRate !== detail.taxRate ? 'red' : ''
                          }
                        >
                          {item.taxRateShow + '%'}
                        </span>
                      </div>
                    </li>
                    <li>
                      <span className="field-label">税率</span>
                      {item.taxRate !== item.invoceRate ? (
                        <div className="field-value">
                          <span className="gray">
                            {'附加税率:' + item.invoceRateShow + '%'}
                          </span>
                        </div>
                      ) : (
                        ''
                      )}
                    </li>
                  </ul>
                </div>
              ))}
          </div>
          {!invoiceList?.length === 0 && (
            <LoadMore showLine> 暂无数据</LoadMore>
          )}
        </div>
      </div>
      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10040205') && [0].includes(detail.status) && (
            <Button
              type="default"
              onClick={() => {
                handleDelete();
              }}
              className="m-flex-item u-btn u-btn_warn"
            >
              删除
            </Button>
          )}
          {User.checkAuth('10040206') && [5].includes(detail.status) && (
            <Button
              type="default"
              onClick={() => {
                handleRecall();
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              撤回
            </Button>
          )}
          {User.checkAuth('10040205') &&
            [0, 4, 6, 7].includes(detail.status) && (
              <Button
                type="default"
                onClick={() => {
                  publish();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                确认发出
              </Button>
            )}
          {User.checkAuth('10040203') &&
            [5].includes(detail.status) &&
            workflow.data &&
            workflow.data['invo_cfm_8'].complete && (
              <Button
                type="default"
                onClick={() => {
                  confirm();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                确认
              </Button>
            )}
          {User.checkAuth('10040207') && ![0, 9].includes(detail.status) && (
            <Button
              type="default"
              onClick={() => {
                invalid();
              }}
              className="m-flex-item u-btn u-btn_warn"
            >
              作废
            </Button>
          )}
        </div>
      )}

      {!self.isPurchase && detail.invoiceOriginator !== 1 && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('20040202') && detail.status === 0 && (
            <Button
              type="default"
              onClick={() => {
                handleDelete();
              }}
              className="m-flex-item u-btn u-btn_warn"
            >
              删除
            </Button>
          )}
          {User.checkAuth('20040205') &&
            ([4, 6, 7].includes(detail.status) ||
              (detail.status === 0 && detail.deliveryApplyFlag === 0)) && (
              <Button
                type="default"
                onClick={() => {
                  publish();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                确认发出
              </Button>
            )}
          {User.checkAuth('20040204') && [5].includes(detail.status) && (
            <Button
              type="default"
              onClick={() => {
                handleRecall();
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              撤回
            </Button>
          )}
          {User.checkAuth('20040205') && ![0, 8, 9].includes(detail.status) && (
            <Button
              type="default"
              onClick={() => {
                invalid();
              }}
              className="m-flex-item u-btn u-btn_warn"
            >
              作废
            </Button>
          )}
        </div>
      )}
      <Modal></Modal>
      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }
    </div>
  );
}

InvoiceDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceDetail);
